import axios from '@app/config/axios.config';

export interface UserLogin {
    id: number;
    userName: string;
    email?: string;
    roles: string[];
    createdAt: string;
    updatedAt: string;
}

export async function getCollaborateurs() {
    const response = await axios.get('/user-login/collaborateur');
    return response.data;
}
